// Assets - Banks
import LogoBCA from "@public/png/logo-bca.png"
import LogoMandiri from "@public/png/logo-mandiri.png"
import LogoBRI from "@public/png/logo-bri.png"
import LogoBSI from "@public/png/bsi-bank.png"
import LogoCIMB from "@public/png/logo-cimb.png"
import LogoBNI from "@public/png/logo-bni.png"
import LogoDanamon from "@public/png/logo-danamon.png"
import LogoMyBank from "@public/png/logo-mybank.png"
import LogoPaninBank from "@public/png/logo-panin-bank.png"

export const LOGOS = [
  {
    url: LogoBCA,
    width: 63,
    height: 20,
    name: "Bank BCA",
    Mwidth: 50.462,
    Mheight: 16
  },
  {
    url: LogoBNI,
    width: 61,
    height: 18,
    name: "Bank BNI",
    Mwidth: 55.086,
    Mheight: 16
  },
  {
    url: LogoBRI,
    width: 53,
    height: 20,
    name: "Bank BRI",
    Mwidth: 42.222,
    Mheight: 16
  },
  {
    url: LogoBSI,
    width: 84,
    height: 24,
    name: "Bank BSI",
    Mwidth: 56,
    Mheight: 16
  },
  {
    url: LogoMandiri,
    width: 89,
    height: 26,
    name: "Bank Mandiri",
    Mwidth: 54.701,
    Mheight: 16
  },
  {
    url: LogoDanamon,
    width: 95.256,
    height: 24,
    name: "Bank Danamon",
    Mwidth: 63.504,
    Mheight: 16
  },
  {
    url: LogoCIMB,
    width: 130,
    height: 20,
    name: "Bank CIMB",
    Mwidth: 104.357,
    Mheight: 16
  },
  {
    url: LogoMyBank,
    width: 104.237,
    height: 24,
    name: "MayBank",
    Mwidth: 69.492,
    Mheight: 16
  },
  {
    url: LogoPaninBank,
    width: 128,
    height: 16,
    name: "Panin Bank",
    Mwidth: 128,
    Mheight: 16
  },
]
